import Button from '@carvana/ds-button';
import Skeleton from '@carvana/ds-skeleton';
import { SebastianStatus } from '~/constants/common/SebastianStatus';
import { useConfiguration } from '~/context/common/StaticContext';

type AskSomethingElseProps = {
  onClick: () => void;
  sebastianStatus: SebastianStatus;
};

export default function AskSomethingElse({
  onClick,
  sebastianStatus
}: AskSomethingElseProps) {
  const { shouldUseTitleCasing } = useConfiguration();
  const shouldShowSkeleton = sebastianStatus !== SebastianStatus.Ready;

  if (shouldShowSkeleton) {
    return (
      <Skeleton
        className="overflow-hidden rounded-full"
        data-testid="ask-something-else-skeleton"
        height="36px"
        width="147px"
      />
    );
  }

  return (
    <Button
      className="w-fit rounded-full"
      data-adobe-id={null}
      data-analytics-id={null}
      data-testid="ask-something-else-button"
      onClick={onClick}
      size="sm"
      variant="primary"
    >
      {shouldUseTitleCasing ? 'Ask Something Else' : 'Ask something else'}
    </Button>
  );
}
